import React from 'react'
import Lottie from "react-lottie";
import MoneyBack_json from "../../animation/MoneyBack.json"
import './Verified.css'
const MoneyBack = () => {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: MoneyBack_json,
        rendererSettings: {
          preserveAspectRatio: "xMidYMid slice",
        },
      };
  return (
    <>
     <section className='lottie-animation-div'>
        <div className='Footer-lottie mt-4 mt-sm-3 mt-md-0 mt-lg-0 mt-xl-0 mt-xxl-0'>
          <Lottie 
            options={defaultOptions} 
             />
        </div>
      </section>
    </>
  )
}

export default MoneyBack